/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import emptiness from 'shared/ui/mixins/common/emptiness';

// Components
const __vue_script__ = {
    name: 'MetaFieldset',

    mixins: [emptiness],

    props: {
        fieldset: {
            type: Array,
            required: true
        },

        settings: {
            type: Object,
            required: true
        },

        context: {
            type: String,
            default: null
        },

        edit: {
            type: Boolean,
            default: false
        },

        value: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            default: () => ({})
        },

        disabled: {
            type: Boolean,
            default: null // Not an error, this is a special case
        }
    },

    methods: {
        getFlags(vars) {
            /**
             * @see https://vee-validate.logaretm.com/v2/guide/flags.html#flags
             */
            const {
                untouched, touched, dirty, pristine,
                valid, invalid, validated, changed
            } = vars;
            return {
                untouched, touched, dirty, pristine,
                valid, invalid, validated, changed
            };
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasNoChildren)?_c('fieldset',{ref:"fieldset"},[_vm._l((_vm.fieldset),function(control){return [(Array.isArray(control))?_c('div',{staticClass:"grouped-controls"},[_c('div',{staticClass:"form-groups"},_vm._l((control),function(c){return _c('validation-provider',{key:((c.order) + "-" + (c.field)),attrs:{"rules":_vm.$utils.controls.getControlValidators(c, { model: _vm.value }),"slim":"slim","name":c.field,"mode":"eager"},scopedSlots:_vm._u([{key:"default",fn:function(slotData){return [_c('meta-control',{attrs:{"settings":_vm.settings,"context":_vm.context,"control":c,"disabled":_vm.disabled,"edit":_vm.edit,"errors":slotData.errors,"event":_vm.event,"parent-model":_vm.value,"statuses":_vm.getFlags(slotData)},on:{"behaviour":function (behaviour) { return _vm.$emit('behaviour', behaviour); },"disable":function($event){return _vm.$emit('disable', $event)},"multi-input":function (field, value) { return _vm.$emit('multi-input', field, value); },"reload":function($event){return _vm.$emit('reload', $event)},"rev":function (rev) { return _vm.$emit('rev', rev); },"save":function($event){return _vm.$emit('save', $event)}},model:{value:(_vm.value[c.field]),callback:function ($$v) {_vm.$set(_vm.value, c.field, $$v)},expression:"value[c.field]"}})]}}],null,true)})}),1)]):_c('validation-provider',{key:((control.order) + "-" + (control.field)),attrs:{"rules":_vm.$utils.controls.getControlValidators(control, { model: _vm.value }),"slim":"slim","name":control.field,"mode":"eager"},scopedSlots:_vm._u([{key:"default",fn:function(slotData){return [_c('meta-control',{attrs:{"settings":_vm.settings,"context":_vm.context,"control":control,"disabled":_vm.disabled,"edit":_vm.edit,"errors":slotData.errors,"event":_vm.event,"parent-model":_vm.value,"statuses":_vm.getFlags(slotData)},on:{"behaviour":function (behaviour) { return _vm.$emit('behaviour', behaviour); },"disable":function($event){return _vm.$emit('disable', $event)},"multi-input":function (field, value) { return _vm.$emit('multi-input', field, value); },"reload":function($event){return _vm.$emit('reload', $event)},"rev":function (rev) { return _vm.$emit('rev', rev); },"save":function($event){return _vm.$emit('save', $event)}},model:{value:(_vm.value[control.field]),callback:function ($$v) {_vm.$set(_vm.value, control.field, $$v)},expression:"value[control.field]"}})]}}],null,true)})]})],2):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MetaFieldset.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__